package org.solyton.solawi.bid.module.banking.component.modal.sepa

import androidx.compose.runtime.*
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch
import kotlinx.datetime.LocalDate
import org.evoleq.compose.Markup
import org.evoleq.compose.conditional.When
import org.evoleq.compose.date.format
import org.evoleq.compose.form.Form
import org.evoleq.compose.form.field.Field
import org.evoleq.compose.form.label.Label
import org.evoleq.compose.layout.Horizontal
import org.evoleq.compose.layout.Property
import org.evoleq.compose.layout.ReadOnlyProperties
import org.evoleq.compose.layout.Vertical
import org.evoleq.compose.modal.Modal
import org.evoleq.compose.modal.ModalData
import org.evoleq.compose.modal.ModalType
import org.evoleq.compose.modal.Modals
import org.evoleq.compose.style.data.device.DeviceType
import org.evoleq.kotlinx.date.today
import org.evoleq.language.Lang
import org.evoleq.language.Locale
import org.evoleq.math.Source
import org.evoleq.math.emit
import org.evoleq.math.map
import org.evoleq.optics.storage.Storage
import org.evoleq.optics.storage.dispatch
import org.evoleq.optics.storage.nextId
import org.evoleq.optics.storage.put
import org.evoleq.optics.transform.times
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.ElementScope
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Text
import org.solyton.solawi.bid.module.banking.action.sepa.*
import org.solyton.solawi.bid.module.banking.component.list.sepa.*
import org.solyton.solawi.bid.module.banking.component.properties.sepa.PaymentsOverviewProperties
import org.solyton.solawi.bid.module.banking.component.properties.sepa.PaymentsProperties
import org.solyton.solawi.bid.module.banking.component.properties.sepa.paymentsPropertyStyles
import org.solyton.solawi.bid.module.banking.component.tab.sepa.TabParagraphWrapper
import org.solyton.solawi.bid.module.banking.data.*
import org.solyton.solawi.bid.module.banking.data.api.*
import org.solyton.solawi.bid.module.banking.data.application.BankingApplication
import org.solyton.solawi.bid.module.banking.data.sepa.PaymentExecutionStatus
import org.solyton.solawi.bid.module.banking.data.sepa.SepaSequenceType
import org.solyton.solawi.bid.module.banking.data.sepa.collection.SepaCollection
import org.solyton.solawi.bid.module.banking.data.sepa.mandate.SepaMandate
import org.solyton.solawi.bid.module.banking.data.sepa.message.SepaMessage
import org.solyton.solawi.bid.module.banking.data.sepa.payment.SepaPayment
import org.solyton.solawi.bid.module.banking.data.sepa.payment.SepaPaymentHistories
import org.solyton.solawi.bid.module.banking.data.sepa.payment.SepaPaymentLink
import org.solyton.solawi.bid.module.banking.service.sepa.isCandidateForNextPeriodPayment
import org.solyton.solawi.bid.module.control.button.*
import org.solyton.solawi.bid.module.dialog.i18n.dialogModalTexts
import org.solyton.solawi.bid.module.list.style.ListStyles
import org.solyton.solawi.bid.module.list.style.defaultListStyles
import org.solyton.solawi.bid.module.scrollable.Scrollable
import org.solyton.solawi.bid.module.scrollable.ScrollableStyles
import org.solyton.solawi.bid.module.style.form.dateInputDesktopStyle
import org.solyton.solawi.bid.module.style.form.fieldDesktopStyle
import org.solyton.solawi.bid.module.style.form.formDesktopStyle
import org.solyton.solawi.bid.module.style.form.formLabelDesktopStyle
import org.solyton.solawi.bid.module.style.modal.commonModalStyles
import org.solyton.solawi.bid.module.tabs.component.*
import org.solyton.solawi.bid.module.tabs.style.TabStyles
import org.w3c.dom.HTMLElement

data class ManageCollectionPaymentsState(
    val executionDate: LocalDate? = null
)

// TODO Remove? Obsolete?
sealed class ManageCollectionPayments {

    data class AttachPayments(
        val executionDate: LocalDate,
        val remittanceInformation: RemittanceInformation? = null
    ): ManageCollectionPayments()

    data class CreateMessage(
        val executionDate: LocalDate,
        val remittanceInformation: RemittanceInformation? = null
    ): ManageCollectionPayments()

    data class CreateRecurringMessage(
        val executionDate: LocalDate,
        val paymentIds: List<SepaPaymentId>,
        val remittanceInformation: RemittanceInformation? = null
    )
}

sealed class Tabs {

    interface Id {
        val id: Int
    }
    class Payments : Id {
        override val id = 0
        enum class Paragraphs {
            OVERVIEW,
            CREATE_NEW_PAYMENTS,
            PAYMENTS_CREATED,
            PAYMENTS_MESSAGE_CREATED,
            PAYMENTS_SENT,
            PAYMENTS_MESSAGE_SETTLED,
            PAYMENTS_PENDING,
            PAYMENTS_FAILED,
            PAYMENTS_CONFIRMED,
            PAYMENTS_DROPPED,
        }
    }
    class PaymentHistory : Id {
        override val id = 1
    }

    class Messages : Id {
        override val id: Int = 2
    }
}

private enum class TabId(val id: Int) {
    Payments (0),
    PaymentHistories(1),
    Messages(2),
}

data class UIState(
    val selectedTab: Int = 0,
    val selectedParagraph: Tabs.Payments.Paragraphs = Tabs.Payments.Paragraphs.OVERVIEW
)

@Markup
fun Storage<Modals<Int>>.showManagePaymentsOfSepaCollectionModal(
    storage: Storage<BankingApplication>,
    texts: Lang.Block,
    device: Source<DeviceType>,
    uiState: UIState,
    setUiState: (UIState) -> Unit,
    sepaCollection: Source<SepaCollection>,
    sepaMessages: Source<List<SepaMessage>>,
    sepaPaymentLinks: Source<List<SepaPaymentLink>>,
    manageCollectionPaymentsState: ManageCollectionPaymentsState,
    setManageCollectionPaymentsState: (ManageCollectionPaymentsState) -> Unit,
    update: () -> Unit
) = with(nextId()) {
    put(
        this to ModalData(this,
            ModalType.Dialog,
            ManagePaymentsOfSepaCollectionModal(
                this,
                texts,
                this@showManagePaymentsOfSepaCollectionModal,
                storage,
                device,
                uiState,
                setUiState,
                sepaCollection,
                sepaMessages,
                sepaPaymentLinks,
                manageCollectionPaymentsState,
                setManageCollectionPaymentsState,
                update = update
            )
        )
    )
}

@Markup
@Suppress("FunctionName", "CyclomaticComplexMethod")
fun ManagePaymentsOfSepaCollectionModal(
    id: Int,
    texts: Lang.Block,
    modals: Storage<Modals<Int>>,
    storage: Storage<BankingApplication>,
    device: Source<DeviceType>,
    uiState: UIState,
    setUiState: (UIState) -> Unit,
    sepaCollectionSource: Source<SepaCollection>,
    sepaMessages: Source<List<SepaMessage>>,
    sepaPaymentLinks: Source<List<SepaPaymentLink>>,
    manageCollectionPaymentsState: ManageCollectionPaymentsState,
    setManageCollectionPaymentsState: (ManageCollectionPaymentsState) -> Unit,
    update: ()->Unit
): @Composable ElementScope<HTMLElement>.()->Unit = Modal(
    type = ModalType.Dialog,
    id = id,
    modals = modals,
    device = device,
    onOk = {
        update()
    },
    onCancel = {},
    texts = texts,
    styles = commonModalStyles(device).modifyContainerStyle {
        //height(80.vh)
    },
) {
    val scope = rememberCoroutineScope()
    val sepaCollection = sepaCollectionSource.emit()
    val tabStyles = TabStyles()
    val scrollableStyles = ScrollableStyles()

    var selectedTab by remember { mutableStateOf(uiState.selectedTab) }
    var paragraphState by remember { mutableStateOf(Tabs.Payments.Paragraphs.OVERVIEW) }
    LaunchedEffect(selectedTab, paragraphState) {
        setUiState(UIState(selectedTab, paragraphState))
    }

    var executionDate by remember(manageCollectionPaymentsState) {
        mutableStateOf(manageCollectionPaymentsState.executionDate)
    }
    LaunchedEffect(executionDate) {
        setManageCollectionPaymentsState(manageCollectionPaymentsState.copy(executionDate = executionDate))
    }


    key(sepaCollection) {
        TabsWrapper(tabStyles.tabsWrapperStyles) {
            TabSelectionBar(tabStyles.tabSelectionBarStyles) {
                TabTrigger(
                    tabStyles.tabTriggerStyles,
                    id = TabId.Payments.id,
                    currentTab = selectedTab,
                    trigger = { selectedTab = TabId.Payments.id }
                ) {
                    Text("Payments")
                }
                TabTrigger(
                    tabStyles.tabTriggerStyles,
                    id = TabId.Messages.id,
                    currentTab = selectedTab,
                    trigger = { selectedTab = TabId.Messages.id }
                ) {
                    Text("Messages")
                }
                TabTrigger(
                    tabStyles.tabTriggerStyles,
                    id = TabId.PaymentHistories.id,
                    currentTab = selectedTab,
                    trigger = { selectedTab = TabId.PaymentHistories.id }
                ) {
                    Text("Payment Histories")
                }
            }
            TabContentWrapper(tabStyles.tabContentWrapperStyles) {
                TabContent(
                    tabStyles.tabContentStyles,
                    TabId.Payments.id,
                    selectedTab
                ) {
                    val paymentHistory = SepaPaymentHistories.build(
                        sepaCollection.sepaPayments.map{it.sepaPaymentId},
                        sepaPaymentLinks.emit()
                    )

                    val usedMandateIds =
                        sepaCollection.sepaPayments.map { it.sepaMandateId }.distinct()
                    val mandatesWithoutPayments = sepaCollection.sepaMandates.filter { mandate ->
                        usedMandateIds.none { it == mandate.sepaMandateId }
                    }

                    val openPayments =
                        sepaCollection.sepaPayments.filter { payment -> payment.status == PaymentExecutionStatus.CREATED }

                    val messageCreatedPayments =
                        sepaCollection.sepaPayments.filter { payment -> payment.status == PaymentExecutionStatus.MESSAGE_CREATED }

                    val sentPayments =
                        sepaCollection.sepaPayments.filter { payment -> payment.status == PaymentExecutionStatus.SENT }

                    val pendingPayments =
                        sepaCollection.sepaPayments.filter { payment -> payment.status == PaymentExecutionStatus.PENDING }
                    val settledPayments =
                        sepaCollection.sepaPayments.filter { payment -> payment.status == PaymentExecutionStatus.MESSAGE_SETTLED }
                    val failedPayments =
                        sepaCollection.sepaPayments.filter { payment -> payment.status == PaymentExecutionStatus.FAILED }
                    val confirmedPayments =
                        sepaCollection.sepaPayments.filter { payment -> payment.status in listOf( PaymentExecutionStatus.CONFIRMED, PaymentExecutionStatus.PAYED_MANUALLY ) }

                    val droppedPayments =
                        sepaCollection.sepaPayments.filter {payment -> payment.status == PaymentExecutionStatus.DROPPED }

                    val forbiddenSeqTypes = listOf(
                        SepaSequenceType.FNAL,
                        SepaSequenceType.OOFF,
                        SepaSequenceType.UNCLEAR
                    )
                    val nextPeriodPaymentCreationCandidates = (confirmedPayments + failedPayments).filter {
                        it.isCandidateForNextPeriodPayment(paymentHistory, forbiddenSeqTypes)
                    }

                    val retryPaymentCreationCandidates = failedPayments.filter {
                        it.retrySuccessorId == null && it.sequenceType !in forbiddenSeqTypes
                    }

                    // GUI states
                    // var detailsHeightState by remember { mutableStateOf(60.0)}

                    Horizontal {
                        Vertical({
                            width(20.percent)
                            flexGrow(1)
                        }) {
                            // TabTitle("Manage Payments")
                            TabParagraphWrapper(
                                onClick = { paragraphState = Tabs.Payments.Paragraphs.OVERVIEW }
                            ) {
                                TabParagraph("Overview")
                                // We only want to count payments that have not been retried to avoid double counting
                                PaymentsProperties(sepaCollection.sepaPayments.filter{ it.retrySuccessorId == null })
                            }
                            Scrollable(
                                scrollableStyles
                                // .modifyContainerStyle { minHeight(detailsHeightState.vh) }
                            ) {
                                TabParagraphWrapper(
                                    onClick = { paragraphState = Tabs.Payments.Paragraphs.CREATE_NEW_PAYMENTS }
                                ) {
                                    TabParagraph("Create new Payments")

                                    ReadOnlyProperties(
                                        listOf(
                                            Property("Execution Date", executionDate?.format(Locale.Iso)?: ""),
                                            Property("New Mandates", mandatesWithoutPayments.size ),
                                            Property("Next Period", nextPeriodPaymentCreationCandidates.size),
                                            Property("Retry Candidates", retryPaymentCreationCandidates.size)
                                        ),
                                        paymentsPropertyStyles
                                    )
                                }

                                TabParagraphWrapper(
                                    onClick = { paragraphState = Tabs.Payments.Paragraphs.PAYMENTS_CREATED }
                                ) {
                                    TabParagraph("Open Payments / Recurring")
                                    PaymentsProperties(openPayments)
                                }

                                TabParagraphWrapper(
                                    onClick = { paragraphState = Tabs.Payments.Paragraphs.PAYMENTS_MESSAGE_CREATED }
                                ) {
                                    TabParagraph("Ready for Submission to the Bank")
                                    PaymentsProperties(messageCreatedPayments)
                                }

                                TabParagraphWrapper(
                                    onClick = { paragraphState = Tabs.Payments.Paragraphs.PAYMENTS_SENT }
                                ) {
                                    TabParagraph("Sent Payments (Sent to Bank)")
                                    PaymentsProperties(sentPayments)
                                }

                                TabParagraphWrapper(
                                    onClick = { paragraphState = Tabs.Payments.Paragraphs.PAYMENTS_PENDING }
                                ) {
                                    TabParagraph("Pending Payments")
                                    PaymentsProperties(pendingPayments)
                                }

                                TabParagraphWrapper(
                                    onClick = { paragraphState = Tabs.Payments.Paragraphs.PAYMENTS_MESSAGE_SETTLED }
                                ) {
                                    TabParagraph("Message settled")
                                    PaymentsProperties(settledPayments)
                                }

                                TabParagraphWrapper(
                                    onClick = { paragraphState = Tabs.Payments.Paragraphs.PAYMENTS_FAILED }
                                ) {
                                    TabParagraph("Failed Payments")
                                    // We only want to see failed payments that have not been retried
                                    PaymentsProperties(failedPayments.filter { it.retrySuccessorId == null })
                                }

                                TabParagraphWrapper(
                                    onClick = { paragraphState = Tabs.Payments.Paragraphs.PAYMENTS_CONFIRMED }
                                ) {
                                    TabParagraph("Confirmed Payments")
                                    PaymentsProperties(confirmedPayments)
                                }

                                TabParagraphWrapper(
                                    isLast = true,
                                    onClick = { paragraphState = Tabs.Payments.Paragraphs.PAYMENTS_DROPPED }
                                ) {
                                    TabParagraph("Dropped Payments")
                                    PaymentsProperties(droppedPayments)
                                }
                            }
                        }
                        Vertical({
                            paddingLeft(5.px)
                            width(80.percent)
                            border {
                                style = LineStyle.Solid
                                width = 1.px
                                color = Color.gray
                            }
                            borderWidth(0.px, 0.px, 0.px, 1.px)
                        }) {
                            When(paragraphState == Tabs.Payments.Paragraphs.OVERVIEW) {
                                TabTitle("Overview")
                                PaymentsOverviewProperties(sepaCollection.sepaPayments)
                            }
                            val listStyles = defaultListStyles.modifyFilter {
                                width(10.percent)
                            }
                            When(paragraphState == Tabs.Payments.Paragraphs.CREATE_NEW_PAYMENTS) {
                                CreateNewPayments(
                                    sepaCollection,
                                    executionDate,
                                    {executionDate = it},
                                    mandatesWithoutPayments,
                                    nextPeriodPaymentCreationCandidates,
                                    retryPaymentCreationCandidates,
                                    listStyles,
                                    scrollableStyles,
                                    scope,
                                    storage,
                                    device,
                                )
                            }
                            When(paragraphState == Tabs.Payments.Paragraphs.PAYMENTS_CREATED) {
                                RecentlyCreatedPayments(
                                    sepaCollection,
                                    openPayments,
                                    sepaMessages,
                                    listStyles,
                                    scope,
                                    storage,
                                    device,
                                    id
                                )
                            }
                            When(paragraphState == Tabs.Payments.Paragraphs.PAYMENTS_MESSAGE_CREATED) {
                                PaymentsReadyToBeSentToTheBank(
                                    sepaCollection,
                                    messageCreatedPayments,
                                    listStyles,
                                )
                            }
                            When(paragraphState == Tabs.Payments.Paragraphs.PAYMENTS_SENT) {
                                PaymentsSentToTheBank(
                                    sepaCollection,
                                    sentPayments,
                                    listStyles,
                                )
                            }
                            When(paragraphState == Tabs.Payments.Paragraphs.PAYMENTS_PENDING) {
                                PendingPayments(
                                    sepaCollection,
                                    pendingPayments,
                                    listStyles,
                                )
                            }
                            When(paragraphState == Tabs.Payments.Paragraphs.PAYMENTS_MESSAGE_SETTLED) {
                                SettledPayments(
                                    sepaCollection,
                                    settledPayments,
                                    listStyles,
                                    scope,
                                    storage,
                                    device,
                                    id,
                                )
                            }
                            When(paragraphState == Tabs.Payments.Paragraphs.PAYMENTS_CONFIRMED) {
                                ConfirmedPayments(
                                    sepaCollection,
                                    confirmedPayments,
                                    listStyles,
                                    scope,
                                    storage,
                                    device,
                                    id,
                                )
                            }
                            When(paragraphState == Tabs.Payments.Paragraphs.PAYMENTS_FAILED) {
                                FailedPayments(
                                    sepaCollection,
                                    failedPayments,
                                    listStyles,
                                    scope,
                                    storage,
                                    device,
                                    id
                                )
                            }
                            When(paragraphState == Tabs.Payments.Paragraphs.PAYMENTS_DROPPED) {
                                DroppedPayments(
                                    sepaCollection,
                                    droppedPayments,
                                    listStyles,
                                    scope,
                                    storage,
                                    device,
                                    id
                                )
                            }
                        }
                    }
                }
                TabContent(
                    tabStyles.tabContentStyles,
                    TabId.Messages.id,
                    selectedTab
                ) {
                    TabTitle("SEPA Messages")

                    SepaMessageList(
                        storage,
                        Source{sepaCollection},
                        sepaMessages,
                        ListStyles(),
                        id
                    )
                }
                TabContent(
                    tabStyles.tabContentStyles,
                    TabId.PaymentHistories.id,
                    selectedTab
                ) {
                    TabTitle("Payment Histories")

                    SepaPaymentHistoryList(
                        sepaPaymentLinks = sepaPaymentLinks,
                        sepaPayments = sepaCollectionSource map { it.sepaPayments },
                        sepaMandates = sepaCollectionSource map { it.sepaMandates }
                    )
                }
            }
        }
    }
}

/**
 * A composable function to create new SEPA payments based on the provided SEPA collection, execution date, and
 * payment creation candidates. This function allows users to create payments for mandates without payments, retry
 * failed payments, and generate recurring payments.
 *
 * @param sepaCollection The SEPA collection containing mandates and payments.
 * @param executionDate The optional execution date for the payments. Defaults to the current date if null.
 * @param nextPeriodPaymentCreationCandidates A list of SEPA payments eligible for next period creation.
 * @param retryPaymentCreationCandidates A list of SEPA payments eligible for retrying failed payments.
 * @param listStyles Styling configuration for the displayed list elements.
 * @param scrollableStyles Styling configuration for the scrollable container.
 * @param scope The coroutine scope used to launch background operations.
 * @param storage The storage mechanism for managing the current banking application state and actions.
 * @param device The source that determines the type of device interacting with the application.
 */
@Composable
fun CreateNewPayments(
    sepaCollection: SepaCollection,
    executionDate: LocalDate?,
    setExecutionDate: (LocalDate)->Unit,
    mandatesWithoutPayments: List<SepaMandate>,
    nextPeriodPaymentCreationCandidates: List<SepaPayment>,
    retryPaymentCreationCandidates: List<SepaPayment>,
    listStyles: ListStyles,
    scrollableStyles: ScrollableStyles,
    scope: CoroutineScope,
    storage: Storage<BankingApplication>,
    device: Source<DeviceType>,
) {
    TabTitle("Create New payments")
    var executionDateState by remember {
        mutableStateOf(
            executionDate ?: today()
        )
    }
    Scrollable(scrollableStyles.modifyContainerStyle {
        maxHeight(100.percent)
    }.modifyContentStyle {
        minHeight(100.percent)
    }) {
        Vertical({ flexGrow(1) }) {
            Form(formDesktopStyle) {
                Field(fieldDesktopStyle) {
                    // State

                    val initDate = executionDateState.format(Locale.Iso)

                    Label("Execution Date", id = "date", labelStyle = formLabelDesktopStyle)
                    Input(InputType.Date) {
                        id("date")
                        // dataId("create-auction.form.input.date")
                        value(initDate)
                        style {
                            dateInputDesktopStyle()
                            alignSelf(AlignSelf.Start)
                        }
                        onInput {
                            executionDateState = LocalDate.parse(it.value)
                            setExecutionDate(executionDateState)
                        }
                    }
                }
            }

            // These are the ids of the mandates that are visible and checked
            var chosenMandateIds by remember { mutableStateOf(emptyList<SepaMandateId>()) }
            val computeMinHeight : (number: Int) -> CSSNumeric = { (it * 6 + 25).percent }
            ListOfMandateWithoutPayments(
                "Mandates without any payments",
                mandatesWithoutPayments,
                listStyles.modifyListWrapper {
                    flexGrow(1)
                    minHeight(computeMinHeight(minOf(mandatesWithoutPayments.size, 60)))
                    maxHeight(60.vh)
                },
                overallActions = { data ->
                    Horizontal {
                        PlusButton(
                            color = Color.black,
                            bgColor = Color.white,
                            texts = { "Create new payments for selected & visible items" },
                            deviceType = device,
                            isDisabled = false

                        ) {
                            scope.launch {
                                chosenMandateIds =
                                    data.visibleItems.filter { it in data.checkedItems && data.checkedItems[it] == true }

                                if (chosenMandateIds.isEmpty()) return@launch
                                (storage * bankingApplicationActions) dispatch createSepaPaymentsForCollection(
                                    data = CreateSepaPaymentsForCollection(
                                        sepaCollectionId = sepaCollection.sepaCollectionId,
                                        executionDate = executionDateState,
                                        mandateIds = chosenMandateIds
                                    ),
                                    targetCollectionId = sepaCollection.sepaCollectionId
                                )
                            }
                        }
                    }
                }
            )
            ListOfPayments(
                "Candidates for recurring payments:",
                sepaCollection.sepaMandates,
                nextPeriodPaymentCreationCandidates,
                listStyles.modifyListWrapper {
                    flexGrow(1)
                    minHeight(computeMinHeight(minOf(nextPeriodPaymentCreationCandidates.size, 60)))
                    maxHeight(60.vh)
                },
                overallActions = { data ->
                    Horizontal {
                        PlusButton(
                            color = Color.black,
                            bgColor = Color.white,
                            texts = { "Create new payments for selected & visible items" },
                            deviceType = device,
                            isDisabled = false
                        ) {
                            scope.launch {
                                (storage * bankingApplicationActions) dispatch createSuccessorsForPayments(
                                    data = CreateSepaPaymentSuccessors(
                                        executionDate = executionDateState,
                                        paymentIds = data.selectedVisiblePaymentIds(),
                                        kind = SuccessorKind.NEXT_PERIOD
                                    ),
                                    targetCollectionId = sepaCollection.sepaCollectionId
                                )
                            }
                        }
                    }
                }
            )

            ListOfPayments(
                "Candidates for retry payments:",
                sepaCollection.sepaMandates,
                retryPaymentCreationCandidates,
                listStyles.modifyListWrapper {
                    flexGrow(1)
                    minHeight(computeMinHeight(minOf(retryPaymentCreationCandidates.size, 60)))
                    maxHeight(60.vh)
                },
                overallActions = { data ->
                    Horizontal {
                        PlusButton(
                            color = Color.black,
                            bgColor = Color.white,
                            texts = { "Create new payments for selected & visible items" },
                            deviceType = device,
                            isDisabled = false
                        ) {
                            scope.launch {
                                (storage * bankingApplicationActions) dispatch createSuccessorsForPayments(
                                    data = CreateSepaPaymentSuccessors(
                                        executionDate = executionDateState,
                                        paymentIds = data.selectedVisiblePaymentIds(),
                                        kind = SuccessorKind.RETRY
                                    ),
                                    targetCollectionId = sepaCollection.sepaCollectionId
                                )
                            }
                        }
                    }
                }
            )
        }
    }
}

/**
 * Composable function to display and manage recently created SEPA (Single Euro Payments Area) payments
 * within a given SEPA collection. This function provides actions such as deleting payments or generating
 * SEPA messages based on selected payments.
 *
 * @param sepaCollection The SEPA collection containing details and data of SEPA mandates and payments.
 * @param openPayments A list of currently open SEPA payments to be displayed.
 * @param sepaMessages A reactive source of SEPA messages for generating or managing payments.
 * @param listStyles A set of styles applied to the displayed list of payments.
 * @param scope A coroutine scope for managing asynchronous operations within the function.
 * @param storage Storage access interface for managing banking application data and actions.
 * @param device A reactive source providing the type of device on which the UI is being rendered.
 * @param modalId The ID of the modal associated with this component, used for modal management.
 */
@Composable
fun RecentlyCreatedPayments(
    sepaCollection: SepaCollection,
    openPayments: List<SepaPayment>,
    sepaMessages: Source<List<SepaMessage>>,
    listStyles: ListStyles,
    scope: CoroutineScope,
    storage: Storage<BankingApplication>,
    device: Source<DeviceType>,
    modalId: Int,
) {
    TabTitle("Recently created Payments")
    ListOfPayments(
        null,
        sepaCollection.sepaMandates,
        openPayments,
        listStyles,
        overallActions = { data ->
            Horizontal {
                var sepaMessageModalDataState by remember {
                    mutableStateOf(
                        SepaMessageModalData(
                            sepaCollection = sepaCollection,
                            remittanceInformation = null,
                            messages = sepaMessages.emit()
                        )
                    )
                }
                TrashCanButton(
                    color = Color.black,
                    bgColor = Color.white,
                    texts = { "Delete selected & visible Payments" },
                    deviceType = device,
                ) {
                    scope.launch {
                        (storage * bankingApplicationActions) dispatch deleteSepaPayments(
                            data = DeleteSepaPayments(data.selectedVisiblePaymentIds()),
                            targetCollectionId = sepaCollection.sepaCollectionId
                        )
                    }
                }

                var sepaPaymentsState by remember {
                    mutableStateOf(
                        data.selectedVisibleEntries().map {
                            it.value.payment
                        }
                    )
                }
                BulkEditButton(
                    color = Color.black,
                    bgColor = Color.white,
                    texts = { "Bulk edit selected & visible Payments " },
                    deviceType = device,
                    isDisabled = data.selectedVisiblePaymentIds().isEmpty()
                ) {
                    (storage * bankingApplicationModals).showBulkUpdateSepaPaymentsModal(
                        parentModalId = modalId,
                        storage = storage,
                        texts = bulkUpdateSepaPaymentsModalTexts,
                        device = device,
                        sepaPayments = sepaPaymentsState,
                        setSepaPayments = {
                            sepaPaymentsState = it
                        }
                    ) {

                        scope.launch {
                            val data: UpdateSepaPayments = sepaPaymentsState.map { payment ->
                                with(payment) {
                                    UpdateSepaPayment(
                                        sepaPaymentId,
                                        sepaMandateId,
                                        sepaCollectionId,
                                        amount,
                                        executionDate,
                                        sequenceType.toApiType(),
                                        status.toApiType(),
                                        failureReason,
                                        endToEndId,
                                        sepaMessageId,
                                    )
                                }
                            }.let { UpdateSepaPayments(it) }
                            (storage * bankingApplicationActions) dispatch updateSepaPayments(
                                data = data,
                                targetCollectionId = sepaCollection.sepaCollectionId
                            )
                        }
                    }
                }

                val generateSepaMessageButtonText =
                    "Generate Sepa Message from selected & visible Payments. All these payments must be of the same execution date"

                AnglesRightButton(
                    color = Color.black,
                    bgColor = Color.white,
                    texts = { generateSepaMessageButtonText },
                    deviceType = device,
                    isDisabled = !data.isAllSelectedVisiblePaymentsOfSameExecutionDate()
                ) {
                    (storage * bankingApplicationModals).showUpsertSepaMessageModal(
                        parentModalId = modalId,
                        texts = dialogModalTexts("Create Sepa Message"),
                        device = device,
                        data = sepaMessageModalDataState,
                        setData = { data ->
                            sepaMessageModalDataState = data
                        }
                    ) {
                        scope.launch {

                            val selectedPayments = data.selectedVisibleEntries()
                            val selectedPaymentIds = selectedPayments.map { it.key.paymentId }
                            val executionDate =
                                with(selectedPayments.values.map { it.payment.executionDate }.distinct()) {
                                    if (size == 1) first() else null
                                }
                            // require(executionDate != null) { "Selected payments must have a common execution date" }
                            if (executionDate != null) {
                                (storage * bankingApplicationActions) dispatch generateSepaMessageForCollection(
                                    data = GenerateSepaMessageForCollection(
                                        sepaCollectionId = sepaCollection.sepaCollectionId,
                                        executionDate = executionDate,
                                        sepaPaymentIds = selectedPaymentIds,
                                        remittanceInformation = sepaMessageModalDataState.remittanceInformation?.let {
                                            RemittanceInformation(it)
                                        }
                                    )
                                )
                            } else {
                                // dispatch error message
                                return@launch
                            }
                        }
                    }
                }
            }
        },
        actions = { data ->
            Horizontal {
                var paymentState by remember { mutableStateOf(data.data.payment) }
                EditButton(
                    color = Color.black,
                    bgColor = Color.white,
                    deviceType = device,
                ) {

                    (storage * bankingApplicationModals).showUpdateSepaPaymentModal(
                        modalId,
                        storage,
                        updateSepaPaymentModalTexts,
                        device,
                        paymentState,
                        { payment ->
                            paymentState = payment
                        }
                    ) {
                        scope.launch {
                            (storage * bankingApplicationActions) dispatch updateSepaPayment(
                                data = UpdateSepaPayment(
                                    sepaPaymentId = paymentState.sepaPaymentId,
                                    sepaMandateId = paymentState.sepaMandateId,
                                    sepaCollectionId = sepaCollection.sepaCollectionId,
                                    amount = paymentState.amount,
                                    executionDate = paymentState.executionDate,
                                    sequenceType = paymentState.sequenceType.toApiType(),
                                    status = paymentState.status.toApiType(),
                                    failureReason = paymentState.failureReason
                                ),
                                targetCollectionId = sepaCollection.sepaCollectionId
                            )
                        }
                    }
                }
                TrashCanButton(
                    color = Color.black,
                    bgColor = Color.white,
                    deviceType = device,
                    isDisabled = false
                ) {
                    // delete payments in CREATED state
                    scope.launch {
                        (storage * bankingApplicationActions) dispatch deleteSepaPayment(
                            data = DeleteSepaPayment(data.data.payment.sepaPaymentId),
                            targetCollectionId = sepaCollection.sepaCollectionId
                        )
                    }
                }
            }
        }
    )
}

@Composable
fun PaymentsReadyToBeSentToTheBank(
    sepaCollection: SepaCollection,
    messageCreatedPayments: List<SepaPayment>,
    listStyles: ListStyles,
) {
    TabTitle("Ready to be sent to the bank")
    ListOfPayments(
        null,
        sepaCollection.sepaMandates,
        messageCreatedPayments,
        listStyles,
        isReadOnly = true,
    )
}

@Composable
fun PaymentsSentToTheBank(
    sepaCollection: SepaCollection,
    sentPayments: List<SepaPayment>,
    listStyles: ListStyles,
) {
    TabTitle("Payments sent to to the bank")
    ListOfPayments(
        null,
        sepaCollection.sepaMandates,
        sentPayments,
        listStyles,
        isReadOnly = true,
    )
}

@Markup
@Composable
@Suppress("UnusedParameter")
fun PendingPayments(
    sepaCollection: SepaCollection,
    pendingPayments: List<SepaPayment>,
    listStyles: ListStyles
) {
    TabTitle("Pending Payments")
    ListOfPayments(
        null,
        sepaCollection.sepaMandates,
        pendingPayments,
        listStyles,
        isReadOnly = true,
    )
}


@Composable
fun SettledPayments(
    sepaCollection: SepaCollection,
    settledPayments: List<SepaPayment>,
    listStyles: ListStyles,
    scope: CoroutineScope,
    storage: Storage<BankingApplication>,
    device: Source<DeviceType>,
    modalId: Int,
) {
    TabTitle("Settled Payments")
    ListOfPayments(
        null,
        sepaCollection.sepaMandates,
        settledPayments,
        listStyles,
        overallActions = { data ->
            Horizontal {
                var dataState by remember { mutableStateOf(data) }
                BanButton(
                    color = Color.black,
                    bgColor = Color.white,
                    { "Move selected Payments to the failed state" },
                    device,
                ) {

                    (storage * bankingApplicationModals).showMoveFailedPaymentsModal(
                        parentModalId = modalId,
                        texts = dialogModalTexts("Yeeeeeha!"),
                        device = device,
                        isDataValid = {
                            val selectedPayments = dataState.selectedVisibleEntries()
                            val paymentIds = selectedPayments.map { it.key.paymentId }
                            val failureReasons = selectedPayments
                                .filter { it.value.payment.failureReason != null }
                                .map { it.key.paymentId to it.value.payment.failureReason!! }
                                .toMap()
                            paymentIds.size == failureReasons.size
                        },
                        data = dataState,
                        setData = { newData -> dataState = newData },

                        ) {
                        scope.launch {
                            val selectedPayments = dataState.selectedVisibleEntries()
                            val paymentIds = selectedPayments.map { it.key.paymentId }
                            val failureReasons = selectedPayments
                                .filter { it.value.payment.failureReason != null }
                                .map { it.key.paymentId to it.value.payment.failureReason!! }
                                .toMap()
                            require(failureReasons.size == selectedPayments.size) {
                                "Selected payments and failure reasons count mismatch"
                            }
                            (storage * bankingApplicationActions) dispatch updateSepaPaymentExecutionStatuses(
                                data = UpdateSepaPaymentExecutionStatuses(
                                    newStatus = PaymentExecutionStatus.FAILED.toApiType(),
                                    paymentIds = paymentIds,
                                    failureReasons = failureReasons
                                ),
                                sepaCollection.sepaCollectionId
                            )
                        }
                    }
                }
                SackDollarButton(
                    color = Color.black,
                    bgColor = Color.white,
                    { "Move selected Payments to the confirmed state" },
                    device,
                ) {
                    scope.launch {
                        storage.dispatchStatusChange(
                            newStatus = PaymentExecutionStatus.CONFIRMED,
                            paymentIds = data.selectedVisiblePaymentIds(),
                            targetCollectionId = sepaCollection.sepaCollectionId,
                        )
                    }
                }
            }
        },
        actions = {}
    )
}



@Composable
fun ConfirmedPayments(
    sepaCollection: SepaCollection,
    confirmedPayments: List<SepaPayment>,
    listStyles: ListStyles,
    scope: CoroutineScope,
    storage: Storage<BankingApplication>,
    device: Source<DeviceType>,
    modalId: Int,
) {
    TabTitle("Confirmed Payments")
    ListOfPayments(
        null,
        sepaCollection.sepaMandates,
        confirmedPayments,
        listStyles,
        overallActions = { data ->
            Horizontal {
                var dataState by remember { mutableStateOf(data) }
                BanButton(
                    color = Color.black,
                    bgColor = Color.white,
                    { "Move selected Payments to the failed state" },
                    device,
                ) {

                    (storage * bankingApplicationModals).showMoveFailedPaymentsModal(
                        parentModalId = modalId,
                        texts = dialogModalTexts("Yeeeeeha!"),
                        device = device,
                        isDataValid = {
                            val selectedPayments = dataState.selectedVisibleEntries()
                            val paymentIds = selectedPayments.map { it.key.paymentId }
                            val failureReasons = selectedPayments
                                .filter { it.value.payment.failureReason != null }
                                .map { it.key.paymentId to it.value.payment.failureReason!! }
                                .toMap()
                            paymentIds.size == failureReasons.size
                        },
                        data = dataState,
                        setData = { newData -> dataState = newData },

                        ) {
                        scope.launch {
                            val selectedPayments = dataState.selectedVisibleEntries()
                            val paymentIds = selectedPayments.map { it.key.paymentId }
                            val failureReasons = selectedPayments
                                .filter { it.value.payment.failureReason != null }
                                .map { it.key.paymentId to it.value.payment.failureReason!! }
                                .toMap()
                            require(failureReasons.size == selectedPayments.size) {
                                "Selected payments and failure reasons count mismatch"
                            }
                            (storage * bankingApplicationActions) dispatch updateSepaPaymentExecutionStatuses(
                                data = UpdateSepaPaymentExecutionStatuses(
                                    newStatus = PaymentExecutionStatus.FAILED.toApiType(),
                                    paymentIds = paymentIds,
                                    failureReasons = failureReasons
                                ),
                                sepaCollection.sepaCollectionId
                            )
                        }
                    }
                }
                CommentDollarButton(
                    color = Color.black,
                    bgColor = Color.white,
                    texts = { "Move selected Payments to the manually-payed state" },
                    deviceType = device,
                ) {
                    scope.launch {
                        storage.dispatchStatusChange(
                            newStatus = PaymentExecutionStatus.PAYED_MANUALLY,
                            paymentIds = data.selectedVisiblePaymentIds(),
                            targetCollectionId = sepaCollection.sepaCollectionId,
                        )
                    }
                }
                SackDollarButton(
                    color = Color.black,
                    bgColor = Color.white,
                    { "Move selected Payments to the confirmed state" },
                    device,
                ) {
                    scope.launch {
                        storage.dispatchStatusChange(
                            newStatus = PaymentExecutionStatus.CONFIRMED,
                            paymentIds = data.selectedVisiblePaymentIds(),
                            targetCollectionId = sepaCollection.sepaCollectionId,
                        )
                    }
                }

            }
        }
    )
}

@Composable
fun FailedPayments(
    sepaCollection: SepaCollection,
    failedPayments: List<SepaPayment>,
    listStyles: ListStyles,
    scope: CoroutineScope,
    storage: Storage<BankingApplication>,
    device: Source<DeviceType>,
    modalId: Int,
) {
    TabTitle("Failed Payments")
    ListOfPayments(
        null,
        sepaCollection.sepaMandates,
        failedPayments.filter { it.retrySuccessorId == null },
        listStyles,
        overallActions = { data ->
            Horizontal {
                CommentDollarButton(
                    color = Color.black,
                    bgColor = Color.white,
                    texts = { "Move selected Payments to the manually-payed state" },
                    deviceType = device,
                ) {
                    scope.launch {
                        storage.dispatchStatusChange(
                            newStatus = PaymentExecutionStatus.PAYED_MANUALLY,
                            paymentIds = data.selectedVisiblePaymentIds(),
                            targetCollectionId = sepaCollection.sepaCollectionId,
                        )
                    }
                }
                SackDollarButton(
                    color = Color.black,
                    bgColor = Color.white,
                    { "Move selected Payments to the confirmed state" },
                    device,
                ) {
                    scope.launch {
                        storage.dispatchStatusChange(
                            newStatus = PaymentExecutionStatus.CONFIRMED,
                            paymentIds = data.selectedVisiblePaymentIds(),
                            targetCollectionId = sepaCollection.sepaCollectionId,
                        )
                    }
                }
                var dataState by remember { mutableStateOf(data) }
                SackXMarkButton(
                    color = Color.black,
                    bgColor = Color.white,
                    { "Move selected Payments to the dropped state" },
                    device,
                ) {
                    scope.launch {
                        (storage * bankingApplicationModals).showMoveFailedPaymentsModal(
                            parentModalId = modalId,
                            texts = dialogModalTexts("Yeeeeeha!"),
                            device = device,
                            isDataValid = {
                                val selectedPayments = dataState.selectedVisibleEntries()
                                val paymentIds = selectedPayments.map { it.key.paymentId }
                                val failureReasons = selectedPayments
                                    .filter { it.value.payment.failureReason != null }
                                    .map { it.key.paymentId to it.value.payment.failureReason!! }
                                    .toMap()
                                paymentIds.size == failureReasons.size
                            },
                            data = dataState,
                            setData = { newData -> dataState = newData },

                            ) {
                            scope.launch {
                                val selectedPayments = dataState.selectedVisibleEntries()
                                val paymentIds = selectedPayments.map { it.key.paymentId }
                                val failureReasons = selectedPayments
                                    .filter { it.value.payment.failureReason != null }
                                    .map { it.key.paymentId to it.value.payment.failureReason!! }
                                    .toMap()
                                require(failureReasons.size == selectedPayments.size) {
                                    "Selected payments and failure reasons count mismatch"
                                }
                                (storage * bankingApplicationActions) dispatch updateSepaPaymentExecutionStatuses(
                                    data = UpdateSepaPaymentExecutionStatuses(
                                        newStatus = PaymentExecutionStatus.DROPPED.toApiType(),
                                        paymentIds = paymentIds,
                                        failureReasons = failureReasons
                                    ),
                                    sepaCollection.sepaCollectionId
                                )
                            }
                        }
                    }
                }
            }
        }
    )
}
@Markup
@Composable
@Suppress("UnusedParameter")
fun DroppedPayments(
    sepaCollection: SepaCollection,
    droppedPayments: List<SepaPayment>,
    listStyles: ListStyles,
    scope: CoroutineScope,
    storage: Storage<BankingApplication>,
    device: Source<DeviceType>,
    modalId: Int
) {
    TabTitle("Dropped Payments")
    ListOfPayments(
        null,
        sepaCollection.sepaMandates,
        droppedPayments,
        listStyles,

        overallActions = { data ->
            Horizontal {
                var dataState by remember { mutableStateOf(data) }
                BanButton(
                    color = Color.black,
                    bgColor = Color.white,
                    { "Move selected Payments to the failed state" },
                    device,
                ) {
                    (storage * bankingApplicationModals).showMoveFailedPaymentsModal(
                        parentModalId = modalId,
                        texts = dialogModalTexts("Yeeeeeha!"),
                        device = device,
                        isDataValid = {
                            val selectedPayments = dataState.selectedVisibleEntries()
                            val paymentIds = selectedPayments.map { it.key.paymentId }
                            val failureReasons = selectedPayments
                                .filter { it.value.payment.failureReason != null }
                                .map { it.key.paymentId to it.value.payment.failureReason!! }
                                .toMap()
                            paymentIds.size == failureReasons.size
                        },
                        data = dataState,
                        setData = { newData -> dataState = newData },

                        ) {
                        scope.launch {
                            val selectedPayments = dataState.selectedVisibleEntries()
                            val paymentIds = selectedPayments.map { it.key.paymentId }
                            val failureReasons = selectedPayments
                                .filter { it.value.payment.failureReason != null }
                                .map { it.key.paymentId to it.value.payment.failureReason!! }
                                .toMap()
                            require(failureReasons.size == selectedPayments.size) {
                                "Selected payments and failure reasons count mismatch"
                            }
                            (storage * bankingApplicationActions) dispatch updateSepaPaymentExecutionStatuses(
                                data = UpdateSepaPaymentExecutionStatuses(
                                    newStatus = PaymentExecutionStatus.FAILED.toApiType(),
                                    paymentIds = paymentIds,
                                    failureReasons = failureReasons
                                ),
                                sepaCollection.sepaCollectionId
                            )
                        }
                    }
                }
            }
        }
    )
}

// suspend managePaymentsOfSepaCollection(collection: SepaCollection, data: ManageCollectionPayments)

/**
 * Returns the entries (key -> data) of the items that are both visible (i.e. match the current
 * filter) and currently checked by the user.
 */
private fun OverAllActionData.selectedVisibleEntries(): Map<SepaPaymentListItemKey, SepaPaymentListItemData> =
    itemsMap.filter { it.key in visibleItems && checkedPayments[it.key.paymentId] == true }

/**
 * Convenience for the common pattern of collecting the [SepaPaymentId]s of selected & visible items.
 */
private fun OverAllActionData.selectedVisiblePaymentIds(): List<SepaPaymentId> =
    selectedVisibleEntries().map { it.key.paymentId }

private fun OverAllActionData.isAllSelectedVisiblePaymentsOfSameExecutionDate(): Boolean =
    selectedVisibleEntries().map { it.value.payment.executionDate }.distinct().size == 1

/**
 * Dispatches an [updateSepaPaymentExecutionStatuses] action moving the given [paymentIds] to
 * the [newStatus] for the [targetCollectionId].
 */
private suspend fun Storage<BankingApplication>.dispatchStatusChange(
    newStatus: PaymentExecutionStatus,
    paymentIds: List<SepaPaymentId>,
    targetCollectionId: SepaCollectionId,
) {
    (this * bankingApplicationActions) dispatch updateSepaPaymentExecutionStatuses(
        data = UpdateSepaPaymentExecutionStatuses(
            newStatus = newStatus.toApiType(),
            paymentIds = paymentIds,
        ),
        targetCollectionId = targetCollectionId
    )
}
